var ko = require('knockout'),
  APIHelper = require('_js/APIHelper');

function RegistrationEnd(params) {
  var self = this;

  if (params.step === undefined) {
    throw 'No steps parameter passed to this component!';
  }

  self.parent = params.parent;

  self.step = params.step;
  self.API = params.api;
  self.links = params.links;
  self.currentStep = ko.observable(self.parent.currentStep());
  self.showSuccess = ko.observable(false);
  self.showFail = ko.observable(false);

  // Determine if this page is the current step.
  self.parent.currentStep.subscribe(function(val) {
    if (val === self.step()) {
      self.activateComponent();
      var regData = sessionStorage.getItem('rn-registration');
      if (regData !== undefined && regData !== null) {
        var parsedRegData = JSON.parse(regData);
        parsedRegData.signupType = self.parent.signuptype;
        this.allData = ko.observable(parsedRegData);
        if (parsedRegData.result) {
          self.showSuccess(true);
          self.showFail(false);
        } else {
          self.showFail(true);
          self.showSuccess(false);
        }
      }
    }
  });

  // We need to call this function now incase we reload on this step (which will not trigger
  // the currentStep.subscribe function).
  self.activateComponent();
  var regData = sessionStorage.getItem('rn-registration');
  if (regData !== undefined && regData !== null) {
    var parsedRegData = JSON.parse(regData);
    parsedRegData.signupType = self.parent.signuptype;
    this.allData = ko.observable(parsedRegData);
    if (parsedRegData.result) {
      self.showSuccess(true);
      self.showFail(false);
    } else {
      self.showFail(true);
      self.showSuccess(false);
    }
  }
}

RegistrationEnd.prototype.activateComponent = function() {};

RegistrationEnd.prototype.nextStep = function() {
  // 1: Validate step. If successful, goto next step.
  if (!this.validateInputOnStep()) {
    var location = window.location.href || document.URL;
    APIHelper.post('/api/log/error', {
      message: 'NOT-VALIDATED: registration-end.js',
      context: location,
      parameters: [
        'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
        'platform: ' + navigator.platform
      ]
    });
    return;
  }

  // 2: Store values inputted by the user into Storage.
  this.storeValues();

  // 3: Allow to continue execution.

  this.submitData();
};

module.exports = RegistrationEnd;
